import(/* webpackMode: "eager" */ "/codebuild/output/src3312692948/src/dharmayana-website/src/app/(pages)/learn-more-web/error.tsx");
